<template>

  <li>
    <div :class="draggedOver ? 'dragContainer over' : 'dragContainer'" @drop="drop" @dragover="dragover"
         @dragleave="dragleave">

      <input type="checkbox" v-model="item.structure.checked" @click="changeThis" v-if="this.toExport">


      <span
          :draggable="!toExport && move" @dragstart="dragStart" @drag="drag"
          :style="isClassSelected ? 'background-color: rgba(0, 123, 255, 0.35); color: #004998; border-radius: 4px; ' : 'background-color: #f8f9fa; color: black;'"
          :class="[draggedOver ? 'dragItem over' : 'dragItem', printMode ? 'font-weight-bold' : '']">

                        <span v-if="item.item.length > 0 && !printMode" @click="toggle"
                              :class="item.structure.isOpen ? 'chevron mr-0' : ' chevron mr-1'"><i
                            :class="(item.structure.isOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-right' )"></i></span>

                        <span v-if="item.item.length === 0 && !printMode" class="chevronSpacer"></span>

                        <span :style="(item.structure.changed && showErrors) ? 'color: #007bff' : ''"
                              class="treeItemLabel" @click="selectCurrent">
                            <span :style="(showErrors && itemErrors) ? 'color: red' : ''"><span
                                :style="( item.structure.match == false) ? 'font-weight: normal' : 'font-weight: bold'">({{ item.classificationLabel }}) {{
                                item.classificationLabelName
                              }}</span></span>
                        </span>
                    </span>


      <span v-if="showPopover" class="d-inline-block" :id="`popover-${randomKey}`">
                        <i
                            class="fas fa-info-circle"></i>
                    </span>

      <span v-if="item.containsRecords && showPopover" class="d-inline-block" :id="`gradivoId-${randomKey}`">
                        <i
                            class="fas fa-file-contract"></i>
                    </span>
      <b-popover v-if="showPopover" :target="`gradivoId-${randomKey}`" triggers="hover focus">
        {{ $t('text.treeItem.classificationPlanContainsDocumentsWarning') }}
      </b-popover>


      <b-popover v-if="showPopover" :target="`popover-${randomKey}`" triggers="hover focus">
        <template slot="title">{{ $t('text.treeItem.contentDescription') }}
        </template>
        <dl class="row mb-1">
          <dt class="col-md-6">{{ $t('text.classificationPlanMetadata.classificationLabel') }}</dt>
          <dd class="col-sm-6">{{ item.classificationLabel }}</dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-6">{{ $t('text.classificationPlanMetadata.classificationLabelName') }}</dt>
          <dd class="col-sm-6">{{ item.classificationLabelName }}</dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-12">{{ $t('text.classificationPlanMetadata.expiration') }}</dt>
          <dd class="col-sm-12">
            <div v-if="item.rokHrambe">
              <div class=""
                   v-for="(rokHrambeItem, index) in Object.keys(item.rokHrambe)" :key="'rok_hrambe_' + index">

                <b>rok:</b>
                {{ item.rokHrambe[rokHrambeItem].expiration !== '' ? getRokHrambeReadableLabel(item.rokHrambe[rokHrambeItem].expiration) : '/' }},
                <b>vrsta:</b>
                {{ item.rokHrambe[rokHrambeItem].expirationType !== null ? getVrstaGradivaReadableLabel(item.rokHrambe[rokHrambeItem].expirationType) : '/' }},
                <b>leta:</b>
                {{ (item.rokHrambe[rokHrambeItem].year !== null && item.rokHrambe[rokHrambeItem].year) ? item.rokHrambe[rokHrambeItem].year : '/' }}
                <hr v-if="(index + 1) != item.rokHrambe.length" class="mt-0 mb-0"/>

              </div>
            </div>
            <div v-if="!item.rokHrambe">/</div>
            <div class="clearfix"></div>
          </dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-12">{{ $t('text.classificationPlanMetadata.connectedSystems') }}</dt>
          <dd class="col-sm-12">
            <div class="">
              <div
                  v-if="item.povezaniSistemi"
                  v-for="(povezaniSistemiItem, index) in item.povezaniSistemi" :key="'povezan_sistem_' + index">
                {{ getConnectedSystemReadableLabel(povezaniSistemiItem) }}<span
                  v-if="(index + 1) != item.povezaniSistemi.length">, </span>
              </div>
              <div v-if="!item.povezaniSistemi">/</div>
            </div>
            <div class="clearfix"></div>
          </dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-12">{{ $t('text.classificationPlanMetadata.registry') }}</dt>
          <dd class="col-sm-12">
            <div class="vpisnikiContainer" v-if="item.vpisnik">
                                    <span
                                        v-for="(vpisnikItem, index) in item.vpisnik"
                                        :key="'vpisnik_' + index">{{ getRegisterItemReadableLabel(vpisnikItem) }}<span
                                        v-if="(index + 1) != item.vpisnik.length">, </span>
                                    </span>
            </div>
            <div v-if="!item.vpisnik">/</div>
            <div class="clearfix"></div>
          </dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-6">{{ $t('text.treeItem.creationDate') }}</dt>
          <dd class="col-sm-6">
            {{ item.creationDate ? moment(item.creationDate, "DD-MM-YYYY").format("DD. MM. YYYY") : '/' }}
          </dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-6">{{ $t('text.classificationPlanMetadata.usageStartDate') }}</dt>
          <dd class="col-sm-6">
            {{ item.usageStartDate ? moment(item.usageStartDate, "DD-MM-YYYY").format("DD. MM. YYYY") : '/' }}
          </dd>
        </dl>
        <dl class="row mb-1">
          <dt class="col-md-6">{{ $t('text.classificationPlanMetadata.usageEndDate') }}</dt>
          <dd class="col-sm-6">
            {{ item.usageEndDate ? moment(item.usageEndDate, "DD-MM-YYYY").format("DD. MM. YYYY") : '/' }}
          </dd>
        </dl>
      </b-popover>

      <!--<i class="fas fa-info-circle"></i>-->

      <div v-if="printMode" class="metadata mb-1">
        <ul>
          <li
              v-for="key in Object.keys(item)"
              v-if="key !== 'item' && key !== 'structure'"
              :key="'print_' + key"
          >{{ key }}: {{ item[key] }}
          </li>

        </ul>
      </div>

    </div>

    <ul v-show="item.structure.isOpen || printMode" v-if="item.item">
      <tree-item
          class="item"
          v-for="(item, index) in item.item"
          :key="index"
          :item="item"
          @select-item="$emit('select-item', $event)"
          :selectedClassLabel="selectedClassLabel"
          :to-export="toExport"
          :move="move"
          :printMode="printMode"
          :to-review="toReview"
          :showPopover="showPopover"
          :showErrors="showErrors"
          :selectable="selectable"
      ></tree-item>

    </ul>
  </li>

</template>

<script type="text/javascript">
import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core'
import {faHome} from '@fortawesome/free-solid-svg-icons'

library.add(faHome);

export default {
  name: 'TreeItem',
  props: {
    item: Object,
    depth: Number,
    selectedClassLabel: String,
    toExport: Boolean,
    move: Boolean,
    printMode: Boolean,
    toReview: Boolean,
    showPopover: Boolean,
    showErrors: Boolean,
    selectable: Boolean,
  },
  data: function () {
    return {
      vpisniki: [],
      povezaniSistemi: [],
      rokHrambe: [],
      vrstaGradiva: [],

      isOpen: this.item.structure.isOpen,
      movingClass: {},
      keyChanging: 3,
      draggedOver: false,
      checked: true,
      review: this.$parent.toReview,
      randomKey: Math.random().toString(36).substring(2) + Date.now().toString(36),
      isClassSelected: (this.item.classificationLabel === this.selectedClassLabel),

    }
  },

  watch: {
    selectedClassLabel: function (val) {
      //console.log("SELECTED CLASS LABEL CHANGED", val);
      if (this.selectedClassLabel === this.item.classificationLabel) {
        this.isClassSelected = true;
      } else {
        this.isClassSelected = false;
      }
    },
  },

  mounted() {

    this.vpisniki = this.$store.getters.getRegisterOptions;
    this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions;
    this.rokHrambe = this.$store.getters.getStorageDateOptions;
    this.vrstaGradiva = this.$store.getters.getDocumentTypeOptions;

    this.$root.$on('move', item => {
      this.setMovingClass(item);
    });


    if (this.toReview) {
      console.log("isOpen = false");
      this.isOpen = false;
    } else {
      this.isOpen = this.item.structure.isOpen;
    }
  },

  updated() {
    if (this.review) {
      this.isOpen = false;
    }


  },
  computed: {

    itemErrors() {
      if (this.item.errors) {
        for (let key of Object.keys(this.item.errors)) {
          if (key === "rokHrambe") {
            if (this.item.errors[key].expirationErrors) {
              return true;
            }
          } else if (key === "classificationLabel") {
            if (this.item.errors.classificationLabel.missing || this.item.errors.classificationLabel.valueError) {
              return true;
            }
          } else if (this.item.errors[key]) {
            return true;
          }
        }
      }
      return false;
    }

  },
  methods: {

    showModal(buttonId) {

      this.$root.$emit('bv::tooltip::show', buttonId);
    },

    getItem(item) {
      let classificationPlan = this.$store.getters.getClassificationPlanFiltered;
      for (let i = 0; i < classificationPlan.length; i++) {
        let possibleItem = this.getItemRec(classificationPlan[i], item);
        if (possibleItem != null) {
          return possibleItem;
        }
      }

      return null;
    },

    getItemRec(classificationPlan, item) {
      if (classificationPlan.classificationLabel === item.classificationLabel) {
        return classificationPlan;
      } else {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          let possibleItem = this.getItemRec(classificationPlan.item[i], item);
          if (possibleItem != null) {
            return possibleItem;
          }
        }
      }

      return null;
    },


    // spremeni checked polje
    // klice se onChange pri checkboxu

    changeThis() {

      /*
      console.log("change");
      let classificationPlan = this.$store.getters.getClassificationPlan;
      console.log(classificationPlan);
      for(let i = 0; i < classificationPlan.length; i ++) {
          classificationPlan[i] = this.changeThisRec(classificationPlan[i]);
      }

      this.$store.dispatch("setClassificationPlan", classificationPlan);
      */

      this.$root.$emit('changeThis', this.item);
      this.item = this.getItem(this.item);

    },


    // odpiranje/zapiranje otrok
    toggle: function () {

      this.review = false;
      this.item.structure.isOpen = !this.item.structure.isOpen;
      this.isOpen = !this.isOpen;

    },


    // izbiranje razreda (za urejanje ali deletanje...)
    selectCurrent() {

      if (this.selectable) {
        this.item.structure.isSelected = !this.item.structure.isSelected;
        this.$emit('select-item', this.item);

        this.isClassSelected = !this.isClassSelected;
      }

    },

    // drag & drop funkcije

    //zacetek draganja
    dragStart: function (ev) {
      if (this.item.usageEndDate) {
        swal(this.$t('text.globals.error'), this.$t('text.treeItem.closedClassMoveErrorSwal.content'), "error", {dangerMode: true});
      } else {
        this.$root.$emit('move', this.item);
        ev.dataTransfer.setData('text', 'drag');  // nujno za firefox, te date se ne uporablja
      }
    },

    //med draganjem
    drag: function (ev) {
      //console.log("dragging");
    },


    //sprozi premik razreda
    drop: function (ev) {
      console.log("drop", [this.item, this.movingClass]);
      ev.preventDefault();
      this.$root.$emit('drop', [this.item, this.movingClass]);
      //this.moveClass(this.item, this.movingClass);
      this.draggedOver = false;


    },


    dragover: function (ev) {
      ev.preventDefault();
      this.draggedOver = true;
    },

    dragleave: function (ev) {
      ev.preventDefault();
      this.draggedOver = false;
    },

    //shrani podatke o razredu, ki ga premikamo
    setMovingClass(item) {
      //console.log(item.classificationLabel);
      this.movingClass = item;
    },

    getRegisterItemReadableLabel(registerId) {
      const _this = this;
      if (_this.vpisniki.length > 0) {
        return _.filter(_this.vpisniki, {'id': registerId.toString()})[0].description;
      } else {
        return "";
      }
    },

    getConnectedSystemReadableLabel(connectedSystemId) {
      const _this = this;
      if (_this.povezaniSistemi.length > 0) {
        return _.filter(_this.povezaniSistemi, {'id': connectedSystemId.toString()})[0].description;
      } else {
        return "";
      }
    },


    getVrstaGradivaReadableLabel(vrstaGradivaId) {


      if (vrstaGradivaId == null) {
        return null;
      } else {
        const _this = this;


        for (let i = 0; i < this.vrstaGradiva.length; i++) {
          if (this.vrstaGradiva[i].id.toString() === vrstaGradivaId.toString()) {
            return this.vrstaGradiva[i].description;
          }

        }

        return null;
      }
    },

    getRokHrambeReadableLabel(rokHrambeType) {


      if (rokHrambeType == null) {
        return null;
      } else {

        for (let i = 0; i < this.rokHrambe.length; i++) {
          if (this.rokHrambe[i].type.toString() === rokHrambeType.toString()) {
            return this.rokHrambe[i].explanation;
          }

        }

        return null;
      }

    },


  }
};
</script>

<style>
.popover {
  width: 300px !important;
  max-width: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TreeItem.vue